import {ChangeDetectionStrategy, Component, OnInit, inject} from '@angular/core';
import {TranslationService} from './modules/i18n';
import { NavigationEnd, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { filter } from 'rxjs/operators';
import { UserRegistrationStep1Component } from 'src/app/modules/auth/modals/user-registration-step1/user-registration-step1.component';
import { UserRegistrationStep2Component } from './modules/auth/modals/user-registration-step2/user-registration-step2.component';
import { APIService } from 'src/app/api/api.service';
import { AuthService } from './modules/auth';
import { ToastrService } from 'ngx-toastr';
import {ThemeModeService} from './_metronic/partials/layout/theme-mode-switcher/theme-mode.service';

// language list
import {locale as enLang} from './modules/i18n/vocabs/en';
import {locale as chLang} from './modules/i18n/vocabs/ch';
import {locale as esLang} from './modules/i18n/vocabs/es';
import {locale as jpLang} from './modules/i18n/vocabs/jp';
import {locale as deLang} from './modules/i18n/vocabs/de';
import {locale as frLang} from './modules/i18n/vocabs/fr';

@Component({
  // tslint:disable-next-line:component-selector
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  constructor(
    private translationService: TranslationService,
    private modeService: ThemeModeService,
    private authService: AuthService,
    private apiService: APIService,
    private toastr: ToastrService,
    private router: Router
  ) {
    // register translations
    this.translationService.loadTranslations(
      enLang,
      chLang,
      esLang,
      jpLang,
      deLang,
      frLang
    );
  }

  private modalService = inject(NgbModal);

  ngOnInit() {
    this.modeService.init();

    // Extract query parameters manually from URL
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      const urlTree = this.router.parseUrl(this.router.url);
      const accessKey = urlTree.queryParams['accesskey'];

      const storedKeyData = localStorage.getItem('accessKey');
      let storedAccessKey = null;
      let storedExpiration = 0;

      if (storedKeyData) {
        try {
          const parsedData = JSON.parse(storedKeyData);
          storedAccessKey = parsedData.key;
          storedExpiration = parsedData.expires;
        } catch (error) {
          console.error("Error parsing accessKey from localStorage:", error);
          localStorage.removeItem('accessKey');
        }
      }

      if (accessKey && (new Date().getTime() > storedExpiration || storedAccessKey !== accessKey)) {
        this.apiService.getKiaAuthenticationApiClient().getKeysAccessKeyExists(accessKey).then((result: boolean) => {
          if (result) {
            this.openEmailModal(accessKey);
          }
          else {
            this.toastr.error("Access key not found", 'Failed');
          }
        }).catch(error => {
          this.authService.logout();
          const errorMessage = typeof error.response === 'string' ? error.response.replace(/"/g, '') : error.response?.message;
          this.toastr.error(errorMessage, 'Failed');
        });
      } else {
        if (storedKeyData) {
          console.log('User already registered');
        }
      }
    });
  }

  openEmailModal(accessKey: string) {
    const registrationFlow = {
      email: '',
      step: 1,
      accessKey: accessKey,
      complete: false,
      userDetails: null
    };

    sessionStorage.setItem('registrationFlow', JSON.stringify(registrationFlow));
    this.openCurrentRegistrationStep();
  }

  openCurrentRegistrationStep() {
    const flowString = sessionStorage.getItem('registrationFlow');
    if (!flowString) return;

    const flow = JSON.parse(flowString);

    if (flow.complete) {
      sessionStorage.removeItem('registrationFlow');
      return;
    }

    if (flow.step === 1) {
      const modalRef = this.modalService.open(UserRegistrationStep1Component, {
        backdrop: 'static',
        keyboard: false,
        centered: true
      });

      modalRef.componentInstance.title = "Welcome to KiaLearn Portal. Enter your email address to begin.";
      modalRef.componentInstance.flowKey = 'registrationFlow';

      modalRef.result.then((userLoggedIn: boolean) => {
        if (!userLoggedIn) {
          this.openCurrentRegistrationStep();
        }
      }).catch((error) => { });
    }
    else if (flow.step === 2) {
      const modalRef = this.modalService.open(UserRegistrationStep2Component, {
        backdrop: 'static',
        keyboard: false
      });

      modalRef.componentInstance.title = "Enter your details to complete onboarding";
      modalRef.componentInstance.accessKey = flow.accessKey;
      modalRef.componentInstance.flowKey = 'registrationFlow';

      modalRef.result.then(() => { }).catch((error) => { });
    }
  }
}
